import { format } from 'date-fns';
import { enUS } from 'date-fns/locale';
import React, { FC } from 'react';
import { IFiling } from '../types';
import Links from './Links';

interface IProps {
  filingsArr: IFiling[];
}

const FilingsTable: FC<IProps> = ({ children, filingsArr }) => {
  return (
    <div className="filings__table">
      <div className="filings__table--header montserrat-14-bold">
        <div className="filings__table--col">Filing type</div>
        <div className="filings__table--col">Filing date</div>
        <div className="filings__table--col">Download</div>
      </div>
      {filingsArr.map((filing) => (
        <div className="filings__table--row" key={filing.key}>
          <div className="filings__table--col filings__table--col-mobile-50">
            <div className="filings__table--mobile-col-title">Filing type</div>
            <div>{filing.form}</div>
          </div>

          <div className="filings__table--col filings__table--col-mobile-50">
            <div className="filings__table--mobile-col-title">Filing date</div>
            <div className="mobile-only">
              {format(new Date(filing.date), 'LLLL d, Y', { locale: enUS })}
            </div>
            <div className="desktop-only">{filing.date}</div>
          </div>

          <div className="filings__table--col">
            <div className="filings__table--mobile-col-title">Download</div>
            <div>
              <Links links={filing.links} />
            </div>
          </div>
        </div>
      ))}
      {children}
    </div>
  );
};

export default FilingsTable;
